import { baseURL, formatFetchError, getHeader } from '../util'

export async function vdpViews(params: object): Promise<Record<string, number>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/log/vdp-views?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
